<template>
  <div class="home">
    <div class="strong-font mt-divide content">
      <p>数あるコロナ支援給付金。</p>
      <p>あなたが受けられる制度を1分で無料診断！</p>
      <p>まずは、以下の選択肢から初めてみましょう！</p>
    </div>

    <router-link to="/Diag?belong=Jigyounushi" class="mt-divide choice-block">
      <img src="img/jigyounushi.png" class="symbol" />
      <text-box text="事業主なんだけど..."></text-box>
    </router-link>

    <router-link to="/Diag?belong=Kojin" class="mt-divide choice-block">
      <img src="img/kojin.png" class="symbol" />
      <text-box text="個人なんだけど..."></text-box>
    </router-link>
  </div>
</template>

<script>
import TextBox from '@/components/RoundedTextBox'
export default {
  name: 'home',
  components: {
    TextBox
  }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

img.symbol {
  width: 40%;
}

.choice-block {
  padding: 0 10%;
  text-align: center;
}
</style>